
import {finalize} from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Operation } from '../operation/operation';
import { Revision } from '../revision/revision';
import { RevisionService } from '../revision/revision.service';
import { NotifierService, DialogService } from '../ui';

@Component({
  selector: 't-select-revision',
  templateUrl: './select-revision.component.html',
})
export class SelectRevisionComponent implements OnInit {

  @Input()
  operation: Operation

  @Input()
  selectedRevision: Revision 
  @Output()
  selectedRevisionChange = new EventEmitter();

  revisions: Revision[]

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private revisionService: RevisionService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.fetch();
  }

  private fetch() {
    this.notifier.startProgress();

    this.revisionService
      .revisions(this.operation.id, 'PRODUCTION').pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        this.revisions = result.revisions;

        this.sortRevisions();
      });
  }

  private sortRevisions() {
    this.revisions.sort((a, b) => {
      if(a.number < b.number) {
        return 1;
      }
      else if(a.number > b.number) {
        return -1;
      }
      else {
        return 0;
      }
    });
  }

  onSelect(revision: Revision) {
    this.selectedRevision = revision;
    this.selectedRevisionChange.emit(revision);
  }
}
